

import Navbar from "../Navbar"; // ← adjust path as needed
import ReferralHero from "./components/ReferralHero";
import HowItWorks from "./components/HowItWorks";
import ReferralExample from "./components/ReferralExample";
import WhyPrefer from "./components/WhyPrefer";
import FAQ from "../FAQs";
import { faqsBrands } from "../FAQs_QandAOnly";
import Footer from "../Footer";

const ReferralPage = () => {
  return (
    <div className="min-h-screen bg-[#000000] flex flex-col">

      <Navbar />

      <main className="flex-1 flex flex-col items-center w-full">
        <div className="w-full mx-auto">
          <ReferralHero />
          <HowItWorks />
          <ReferralExample />
          <WhyPrefer />
          <FAQ questions={faqsBrands} />
          <Footer/>
        </div>
      </main>
    </div>
  );
};

export default ReferralPage;